import { decodeQueryParamValue, encodeQueryParamValue } from '/src/utils/query-param-codec';
import { getQueryParamKeys } from '/src/utils/queryParamAliases';

export function getStorageKey(key, keyPersistPrefix) {
  return keyPersistPrefix ? `shell:${keyPersistPrefix}:${key}` : `shell:${key}`;
}

const replaceUrl = (params) => {
  let newString = params.toString();
  if (window.location.hash !== '') {
    newString += window.location.hash;
  }
  if (newString.length > 0) {
    window.history.replaceState(null, document.title, `?${newString}`);
  } else {
    const newPath = window.location.href.split('?')[0];
    window.history.replaceState(null, document.title, newPath);
  }
};

export function getParam(key, fallback, search, keyPersistPrefix) {
  const params = new URLSearchParams(search || window.location.search.slice(1));
  const { preferredKey, fallbackKey } = getQueryParamKeys(key);
  const value = decodeQueryParamValue(params.get(preferredKey) || (fallbackKey ? params.get(fallbackKey) : null));

  const storedValue =
    window.localStorage.getItem(getStorageKey(preferredKey, keyPersistPrefix)) ||
    (fallbackKey ? window.localStorage.getItem(getStorageKey(fallbackKey, keyPersistPrefix)) : null);

  return value || storedValue || fallback;
}

export function setParam(key, value, persist = false, keyPersistPrefix) {
  const { preferredKey, fallbackKey } = getQueryParamKeys(key);
  const params = new URLSearchParams(window.location.search.slice(1));
  const encodedValue = encodeQueryParamValue(value);

  params.set(preferredKey, encodedValue);
  if (fallbackKey) {
    params.delete(fallbackKey);
  }
  if (!value) {
    params.delete(preferredKey);
  }

  if (persist && value) {
    window.localStorage.setItem(getStorageKey(preferredKey, keyPersistPrefix), value);
    if (fallbackKey) {
      window.localStorage.removeItem(getStorageKey(fallbackKey, keyPersistPrefix));
    }
  } else if (persist && !value) {
    window.localStorage.removeItem(getStorageKey(preferredKey, keyPersistPrefix));
    if (fallbackKey) {
      window.localStorage.removeItem(getStorageKey(fallbackKey, keyPersistPrefix));
    }
  }
  replaceUrl(params);
}

export function deleteParam(key, persist = false, keyPersistPrefix) {
  const { preferredKey, fallbackKey } = getQueryParamKeys(key);
  const params = new URLSearchParams(window.location.search.slice(1));

  if (persist) {
    window.localStorage.removeItem(getStorageKey(preferredKey, keyPersistPrefix));
    if (fallbackKey) {
      window.localStorage.removeItem(getStorageKey(fallbackKey, keyPersistPrefix));
    }
  }

  if (params.has(preferredKey) || (fallbackKey && params.has(fallbackKey))) {
    params.delete(preferredKey);
    if (fallbackKey) {
      params.delete(fallbackKey);
    }
    replaceUrl(params);
  }
}

export const getInitialValue = (name, possibleValues) => {
  const param = getParam(name);
  if (possibleValues.includes(param)) {
    return param;
  } else {
    deleteParam(name);
    return null;
  }
};
